import React, { useEffect } from "react"
import types from "prop-types"
import { FormIcon } from "shared/icons"
import Tooltip from "shared/Tooltip"
import removeQueryStringFromLocation from "utils/removeQueryStringFromLocation"
import queryParameter, { QP_CACHE_KEY } from "utils/queryParameter"
import { publicFormPath } from "utils/routeHelpers"

const PublicCategoryFormList = ({ forms }) => {
  const qpCacheKey = queryParameter(QP_CACHE_KEY)
  const cacheKeyQueryString = qpCacheKey ? `?${QP_CACHE_KEY}=${qpCacheKey}` : ""

  useEffect(() => { removeQueryStringFromLocation() }, [])

  return (
    <div className="public-category-form-list">
      {
        forms.map((form) => (
          <Tooltip key={form.slug} text={form.tooltipDescription}>
            <a
              className="public-category-form-list-card"
              href={publicFormPath(form.slug, cacheKeyQueryString)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormIcon className="public-category-form-list-card__icon" form={form} />
              <span>{form.title}</span>
            </a>
          </Tooltip>
        ))
      }
    </div>
  )
}

PublicCategoryFormList.propTypes = {
  forms: types.arrayOf(types.object).isRequired,
}

export default PublicCategoryFormList
